const initial = {
  open: '',
  codes: [],
  search: '',
  selected: []
}

function codes(state = initial, action) {
  switch (action.type) {
    case 'MODAL_CODES':
      return {
        ...state,
        open: action.value
      }
    case 'SEARCH_CODE':
      return {
        ...state,
        search: action.value
      }
    case 'SELECTED_CODES':
      return {
        ...state,
        selected: action.value
      }
    case 'DELETE_CODE':
      return {
        ...state,
        codes: state.codes.filter(item => action.value.indexOf(item.id) < 0)
      }
    case 'GET_CODES':
      return {
        ...state,
        selected: [],
        codes: action.value
      }
    default:
      return state
  }
}

export default codes
